/**
 * Generates a random v4 UUID.
 * @returns {ReturnType<crypto['randomUUID']>} UUID.
 */
export const createUUID = () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, createChar);

/**
 * Creates a random hex character from a given placeholder UUID character.
 * @param {'x' | 'y'} char
 * @returns {string} Random hex value.
 */
const createChar = (char) => {
	const rand = (Math.random() * 16) | 0;
	// don't ask questions
	const value = char === 'x' ? rand : (rand & 0x3) | 0x8;
	return value.toString(16);
};
